const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.6,168h0v-14.4c1.6-19.2-12.8-35.2-32-36.8-7.2-.8-14.4,1.6-20,4.8-11.2,6.4-17.6,18.4-16,31.2v15.2c-9.6,1.6-16.8,9.6-17.6,19.2v44.8c0,11.2,8.8,20,20,20h63.2c10.4,0,19.2-8.8,20-19.2v-44.8c-.8-9.6-8-18.4-17.6-20ZM176.8,136c8.8-5.6,20.8-2.4,26.4,6.4,2.4,3.2,3.2,7.2,2.4,11.2v14.4h-37.6v-14.4c-.8-7.2,3.2-13.6,8.8-17.6ZM223.2,232.8c0,2.4-2.4,4.8-4.8,4.8h-62.4c-2.4,0-4.8-2.4-4.8-4.8v-44.8c0-2.4,2.4-4.8,4.8-4.8h63.2c1.6,0,2.4.8,3.2,1.6.8.8,1.6,2.4,1.6,3.2l-.8,44.8Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,192.8c-4.8-3.2-11.2-1.6-14.4,4-.8,1.6-1.6,3.2-1.6,5.6s1.6,5.6,3.2,8v10.4c0,4,3.2,8,8,8s7.2-4,7.2-8v-10.4c4-4,4-11.2,0-15.2l-2.4-2.4Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,2C69.2,2,15.6,18.8,15.6,50.8v144.8c0,32,52.8,48.8,102.4,48.8s9.6-4,9.6-8.8-4-9.6-8.8-9.6h-.8c-52,0-84-17.6-84-30.4v-43.2c25.6,14.4,54.4,20.8,83.2,20,4.8.8,9.6-2.4,10.4-7.2s-2.4-9.6-7.2-10.4h-2.4c-51.2,0-84-18.4-84-31.2v-43.2c25.6,14.4,55.2,21.6,84.8,20,29.6.8,58.4-5.6,84-20v24c0,4.8,4,9.6,8.8,9.6s9.6-4,9.6-8.8v-54.4c0-32-52.8-48.8-102.4-48.8ZM118,81.2c-52,0-84.8-17.6-84.8-30.4s32.8-30.4,84.8-30.4,84.8,17.6,84.8,30.4-32,30.4-84.8,30.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLock);
export default __webpack_public_path__ + "static/media/data-lock.48a607ae0efe2ffef16f6ea67a1c23d6.svg";
export { ForwardRef as ReactComponent };